import { billing } from '@/services/billing';
import { sleep } from '@/utils/sleep';

const CARD_REFRESH_ATTEMPTS = 3;
const CARD_REFRESH_DELAY_MS = 2000;

/** Reloads billing until it reports a card that was just saved. */
export async function refreshSavedCard(): Promise<void> {
  for (let attempt = 0; attempt < CARD_REFRESH_ATTEMPTS; attempt++) {
    await sleep(CARD_REFRESH_DELAY_MS);
    await billing.initialize.perform({ refresh: true });
  }
}
